<template>
  <div>
    <UiModal
      v-if="newUiEnabled"
      v-model="isNewUiModalOpen"
      size="m"
      :icon="Info"
      :title="$t('How automarking works?')"
      @hide="onHideModal"
    >
      <UiModalSection>
        <UiModalCard>
          <p class="automarking-info__paragraph">{{ $t("automarking_info_intro") }}</p>

          <UiAlert>
            <strong>{{
              $t(
                variant === "registration"
                  ? "automarking_info_important_registration"
                  : "automarking_info_important_edit",
              )
            }}</strong>
          </UiAlert>
        </UiModalCard>

        <UiModalCard>
          <h4 class="automarking-info__heading">
            {{ $t("Where can I change or set up automatic ordering?") }}
          </h4>

          <ol class="automarking-info__list">
            <li>{{ $t("automarking_info_where_step_1") }}</li>
            <li>{{ $t("automarking_info_where_step_2") }}</li>
          </ol>
        </UiModalCard>

        <UiModalCard>
          <h4 class="automarking-info__heading">{{ $t("Useful information") }}</h4>

          <ul class="automarking-info__list">
            <li>{{ $t("automarking_info_tip_1") }}</li>
            <li>{{ $t("automarking_info_tip_2") }}</li>
          </ul>
        </UiModalCard>

        <UiAlert v-if="!isOrderChargeTimeInOrderDay" tone="warning">
          <strong>{{ $t("WARNING!") }}</strong>
          {{ $t("The system will mark your presence only if you have funds on your account.") }}
        </UiAlert>
      </UiModalSection>

      <template #footer>
        <UiButton variant="primary" :icon="Check" @click="isNewUiModalOpen = false">
          {{ $t("Got it") }}
        </UiButton>
      </template>
    </UiModal>

    <b-modal
      v-else
      id="automarkingInfoModal"
      ref="automarkingInfoModal"
      :no-footer="true"
      ok-variant="secondary"
      size="md"
      @close="onHideModal"
      @hide="onHideModal"
    >
      <template #title>
        <UiIcon fa="fa fa-info me-1" /> {{ $t("How automarking works?") }}
      </template>

      <p>{{ $t("automarking_info_intro") }}</p>

      <p>
        <strong>{{
          $t(
            variant === "registration"
              ? "automarking_info_important_registration"
              : "automarking_info_important_edit",
          )
        }}</strong>
      </p>

      <p class="fw-bold mb-1">{{ $t("Where can I change or set up automatic ordering?") }}</p>

      <ol>
        <li>{{ $t("automarking_info_where_step_1") }}</li>
        <li>{{ $t("automarking_info_where_step_2") }}</li>
      </ol>

      <p class="fw-bold mb-1">{{ $t("Useful information") }}</p>

      <ul>
        <li>{{ $t("automarking_info_tip_1") }}</li>
        <li>{{ $t("automarking_info_tip_2") }}</li>
      </ul>

      <p v-if="!isOrderChargeTimeInOrderDay">
        <strong>{{ $t("WARNING!") }}</strong>
        {{ $t("The system will mark your presence only if you have funds on your account.") }}
      </p>
    </b-modal>
  </div>
</template>

<script>
import { Check, Info } from "lucide-vue-next";
import { useNewUiEnabled } from "@/components/newUi/core/useNewUiEnabled";
import { isOrderChargeTimeInOrderDay } from "@/modules/settings/queries/tenantSettingsSelectors";

export default {
  name: "AutomarkingInfoModal",

  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },

    variant: {
      type: String,
      default: "edit",
      validator: (value) => ["registration", "edit"].includes(value),
    },
  },

  emits: ["hide"],

  setup() {
    return { isOrderChargeTimeInOrderDay, newUiEnabled: useNewUiEnabled(), Check, Info };
  },

  data() {
    return {
      isNewUiModalOpen: false,
    };
  },

  watch: {
    show(newValue) {
      if (newValue) {
        this.openModal();
      }
    },
  },

  async mounted() {
    if (this.show) {
      await this.$nextTick();
      this.openModal();
    }
  },

  methods: {
    openModal() {
      if (this.newUiEnabled) {
        this.isNewUiModalOpen = true;
      } else {
        this.$refs.automarkingInfoModal.show();
      }
    },

    onHideModal() {
      this.$emit("hide");
    },
  },
};
</script>
